import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GratuitousProgramsPage from './components/GratuitousPrograms/GratuitousProgramsPage';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Редирект с корня на /free-programs */}
          <Route path="/" element={<Navigate to="/free-programs" replace />} />

          {/* Основной маршрут */}
          <Route path="/free-programs" element={<GratuitousProgramsPage />} />

          {/* Любой другой путь -> редирект */}
          <Route path="*" element={<Navigate to="/free-programs" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;